import { gql } from '@apollo/client';
/**
 * @const GetMewsServiceAvailabilityQuery
 * @since 1.0.0
 */
export const GetMewsServiceAvailabilityQuery = gql `
  query GetMewsServiceAvailability($input: GetMewsServiceAvailabilityInput!) {
    getMewsServiceAvailability(input: $input) {
      categoryAvailabilities {
        categoryId
        categoryName
        availabilities
      }
      timeUnitStartsUtc
    }
  }
`;
